const countryCanadaOnly: { [key: string]: string } = {
  CA: 'Canada',
};

export default countryCanadaOnly;
